<mat-card class="container">
  <form [formGroup]="loginForm">
    <mat-form-field style="display: block;">
      <mat-label>Email</mat-label>
      <input matInput placeholder="Email" type="email" formControlName="user" />
      <mat-error>* Required</mat-error>
    </mat-form-field>
    <mat-form-field style="display: block;">
      <mat-label>Password</mat-label>
      <input matInput placeholder="Password" type="password" formControlName="password" />
      <mat-error>* Required</mat-error>
    </mat-form-field>
  </form>
  <mat-card-actions>
    <button mat-button type="button" (click)="login()">Login</button>
  </mat-card-actions>
</mat-card>
